import type { BuildingCoreSections } from "../../../types/buildings-sections/core";

export const buildingCore: BuildingCoreSections = {
  title: "Hooned",
  addNew: "Lisa uus",
  edit: "Muuda hoonet",
  name: "Hoone nimetus",
  address: "Aadress",
  typeLabel: "Hoone tüüp",
  yearBuilt: "Ehitusaasta",
  netArea: "Netopindala",
  plotArea: "Krundi pindala (m²)",
  costPerSquareMeter: "Maksumus m² kohta",
  description: "Kirjeldus",
  save: "Salvesta",
  cancel: "Tühista",
  updated: "Hoone andmed uuendatud",
  nameUpdated: "Hoone nimetus edukalt uuendatud",
  error: "Viga hoone andmete uuendamisel",
  loading: "Hoonete laadimine...",
  empty: "Hooneid ei leitud",
  nameRequired: "Hoone nimetus on kohustuslik",
  addressRequired: "Aadress on kohustuslik",
  yearRequiredNumeric: "Aasta peab olema number",
  areaRequiredNumeric: "Pindala peab olema number",
  formErrors: "Palun paranda vead vormis",
  buildingDetail: "Hoone detailid",
  buildingNotFound: "Hoonet ei leitud",
  selectBuilding: "Vali hoone",
  typeRequired: "Hoone tüüp on kohustuslik",
  location: "Asukoht",
  constructionType: "Ehitustüüp",
  registryCode: "Hoone registrikood",
  registryCodeInvalid: "Registrikood peab olema täpselt 9 numbrit",
  cadastralCode: "Katastriüksuse kood",
  cadastralCodeInvalid: "Katastriüksuse kood peab olema vormingus XXXXX:XXX:XXXX",
  kinnistuNumber: "Kinnistu number",
  kinnistuNumberInvalid: "Kinnistu number peab sisaldama ainult numbreid (1–10 märki)",
  kinnistuNumberExists: "Selline kinnistu number on juba kasutusel",
  plotAreaInvalid: "Krundi pindala peab olema positiivne arv kuni kahe kümnendkohaga",
  plotAreaRequired: "Krundi pindala on kohustuslik",
  constructionTypes: {
    office: "Kontor",
    retail: "Kaubandus",
    residential: "Elamu",
    logistics: "Logistika",
    industrial: "Tööstus",
    healthcare: "Tervishoid",
    educational: "Haridus",
    hospitality: "Majutus",
    mixed_use: "Segakasutus",
    data_center: "Andmekeskus",
    other: "Muu",
  },
  formSections: {
    landAndRegistry: "Krundi ja registriandmed",
    generalInformation: "Üldandmed",
    buildingAreasVolumes: "Hoone pindalad ja mahud",
    buildingRightsPlanning: "Ehitusõigus ja planeering",
    parkingMobility: "Parkimine ja liikuvus",
    utilitiesTechnical: "Kommunaal- ja tehnosüsteemid",
    certificatesQuality: "Sertifikaadid ja kvaliteedimärgid",
  },
  certifications: {
    title: "Hoone Sertifikaadid",
    addCertificate: "Lisa Sertifikaat",
    certificateType: "Sertifikaadi Tüüp",
    certificateValue: "Väärtus/Tase",
    noCertificates: "Sertifikaate pole veel lisatud",
    selectType: "Vali sertifikaadi tüüp...",
  },
};
